var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import LocalStorage from "./localStorage";
import Tracker from "./tracker";
var ShouldNotRun = /** @class */ (function (_super) {
    __extends(ShouldNotRun, _super);
    function ShouldNotRun(message) {
        if (message === void 0) { message = "Experiment should not run"; }
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ShouldNotRun.prototype);
        _this.name = "ShouldNotRun";
        if (typeof Error.captureStackTrace === "function") {
            Error.captureStackTrace(_this, ShouldNotRun);
        }
        return _this;
    }
    return ShouldNotRun;
}(Error));
var Experiment = /** @class */ (function (_super) {
    __extends(Experiment, _super);
    function Experiment(parameters, currentUrl) {
        var _this = _super.call(this) || this;
        _this.parameters = parameters;
        _this.currentUrl = currentUrl;
        _this.storage = new LocalStorage();
        _this.conversionType = '';
        _this.variantName = '';
        _this.variantId = undefined;
        _this._skipReason = undefined;
        return _this;
    }
    Experiment.prototype.setConvertionType = function (type) {
        this.conversionType = type;
    };
    Experiment.prototype.pickVariant = function () {
        if (!this.parameters.variants || this.parameters.variants.length === 0) {
            throw new ShouldNotRun("No variants configured");
        }
        var storedVariantId = this.storage.get(this.parameters.name, 'variant');
        var variant = this.parameters.variants.find(function (e) { return e.id === storedVariantId; });
        if (!variant) {
            variant = this.parameters.variants[this._randomInt(this.parameters.variants.length)];
            this.storage.set(this.parameters.name, 'variant', variant.id);
        }
        this.variantName = variant.name;
        this.variantId = variant.id;
        return variant;
    };
    Experiment.prototype._randomInt = function (n) {
        var randomArray = new Uint32Array(1);
        crypto.getRandomValues(randomArray);
        var randomValue = randomArray[0];
        return Math.floor((randomValue / (0xFFFFFFFF + 1)) * n);
    };
    Experiment.prototype.shouldRun = function () {
        try {
            this._checkForDuration(this.parameters.durationFrom, this.parameters.durationTo);
            this._checkForSchedule(this.parameters.scheduleFrom, this.parameters.scheduleTo);
            if (this.conversionType !== 'page_view') {
                this._checkForTargets(this.currentUrl, this.parameters.targets, this.parameters.targetCondition);
            }
        }
        catch (error) {
            if (error instanceof ShouldNotRun) {
                this._skipReason = error.message || 'ShouldNotRun';
                return false;
            }
            if (error instanceof Error) {
                this._skipReason = error.message || 'Unknown error';
                return false;
            }
        }
        return true;
    };
    Experiment.prototype.getSkipReason = function () {
        return this._skipReason;
    };
    Experiment.prototype.run = function () {
        if (this.conversionType === 'page_view') {
            try {
                this._checkForTargets(this.currentUrl, this.parameters.targets, this.parameters.targetCondition);
            }
            catch (error) {
                if (error instanceof ShouldNotRun || error instanceof Error) {
                    return;
                }
            }
        }
        if (!this.shouldRun())
            return;
        var hadVariant = !!this.storage.get(this.parameters.name, 'variant');
        var variant;
        try {
            variant = this.pickVariant();
        }
        catch (error) {
            if (error instanceof ShouldNotRun || error instanceof Error) {
                return;
            }
            return;
        }
        // Attach storage so sendEvent can manage X-Event-Token header + persistence
        this.attachStorage(this.storage, this.parameters.name);
        if (!hadVariant) {
            this.sendEvent({
                type: 'impression',
                variant: variant.id,
                abtest: this.parameters.uuid,
            });
        }
        this._activateVariant(variant);
    };
    Experiment.prototype._activateVariant = function (variant) {
        if (typeof variant.activate === 'function') {
            variant.activate();
        }
        else if (typeof variant.activate === 'string') {
            try {
                // Execute the JavaScript code string
                new Function(variant.activate)();
            }
            catch (error) {
                console.error("Failed to execute variant activation code for \"".concat(variant.name, "\":"), error);
            }
        }
    };
    Experiment.prototype._checkForDuration = function (durationFrom, durationTo) {
        var now = new Date();
        if (durationFrom) {
            var from_ = new Date(durationFrom);
            if (isNaN(from_.getTime())) {
                throw new ShouldNotRun('Invalid durationFrom');
            }
            if (now < from_) {
                throw new ShouldNotRun('Before durationFrom');
            }
        }
        if (durationTo) {
            var to_ = new Date(durationTo);
            if (isNaN(to_.getTime())) {
                throw new ShouldNotRun('Invalid durationTo');
            }
            if (now > to_) {
                throw new ShouldNotRun('After durationTo');
            }
        }
    };
    Experiment.prototype._checkForSchedule = function (scheduleFrom, scheduleTo) {
        var now = new Date();
        var makeTime = function (base, h, m, s) {
            var d = new Date(base);
            d.setHours(h, m, s, 0);
            return d;
        };
        var parseHMS = function (value) {
            var parts = value.split(':');
            if (parts.length !== 3)
                return null;
            var nums = parts.map(Number);
            if (nums.some(function (n) { return Number.isNaN(n); }))
                return null;
            return nums;
        };
        // Only scheduleFrom provided: valid from that time to end of day
        if (scheduleFrom && !scheduleTo) {
            var parsed = parseHMS(scheduleFrom);
            if (!parsed)
                throw new ShouldNotRun('Invalid scheduleFrom');
            var fh = parsed[0], fm = parsed[1], fs = parsed[2];
            var fromToday_1 = makeTime(now, fh, fm, fs);
            if (now < fromToday_1)
                throw new ShouldNotRun('Before scheduleFrom');
            return;
        }
        // Only scheduleTo provided: valid from start of day to that time
        if (!scheduleFrom && scheduleTo) {
            var parsed = parseHMS(scheduleTo);
            if (!parsed)
                throw new ShouldNotRun('Invalid scheduleTo');
            var th = parsed[0], tm = parsed[1], ts = parsed[2];
            var toToday_1 = makeTime(now, th, tm, ts);
            if (now > toToday_1)
                throw new ShouldNotRun('After scheduleTo');
            return;
        }
        // Both provided or none
        if (!scheduleFrom || !scheduleTo)
            return; // none provided → no gating
        var fromHMS = parseHMS(scheduleFrom);
        var toHMS = parseHMS(scheduleTo);
        if (!fromHMS || !toHMS)
            throw new ShouldNotRun('Invalid schedule window');
        var from_h = fromHMS[0], from_m = fromHMS[1], from_s = fromHMS[2];
        var to_h = toHMS[0], to_m = toHMS[1], to_s = toHMS[2];
        var fromToday = makeTime(now, from_h, from_m, from_s);
        var toToday = makeTime(now, to_h, to_m, to_s);
        // Overnight window logic
        if (toToday < fromToday) {
            var fromYesterday = new Date(fromToday);
            fromYesterday.setDate(fromYesterday.getDate() - 1);
            var toTomorrow = new Date(toToday);
            toTomorrow.setDate(toTomorrow.getDate() + 1);
            var inWindowPrev = now >= fromYesterday && now <= toToday;
            var inWindowCurr = now >= fromToday && now <= toTomorrow;
            if (!inWindowPrev && !inWindowCurr)
                throw new ShouldNotRun('Outside overnight schedule');
            return;
        }
        // Normal same-day window
        if (now < fromToday || now > toToday)
            throw new ShouldNotRun('Outside schedule window');
    };
    Experiment.prototype._checkForTargets = function (currentUrl, targets, targetCondition) {
        if (!targets || targets.length === 0)
            return; // no gating when empty
        var conditionMet = false;
        targets.forEach(function (t) {
            switch (targetCondition) {
                case 'starts_with':
                    if (currentUrl.startsWith(t)) {
                        conditionMet = true;
                        return;
                    }
                    break;
                case 'ends_with':
                    if (currentUrl.endsWith(t)) {
                        conditionMet = true;
                        return;
                    }
                    break;
                case 'contains':
                    if (currentUrl.includes(t)) {
                        conditionMet = true;
                        return;
                    }
                    break;
                case 'matches':
                    var re = void 0;
                    try {
                        re = new RegExp(t);
                    }
                    catch (_) {
                        throw new ShouldNotRun("Invalid target regex");
                    }
                    if (re.test(currentUrl)) {
                        conditionMet = true;
                        return;
                    }
                    break;
                default:
                    if (currentUrl == t) {
                        conditionMet = true;
                        return;
                    }
                    break;
            }
        });
        if (!conditionMet)
            throw new ShouldNotRun('Target condition not met');
    };
    return Experiment;
}(Tracker));
export default Experiment;
